<div class="card-custom uploads_section">
    <div class="row mt-4 mb-4" style="margin: 0 auto" *ngIf="createdataUpload">
        <div class="col-xl-3 col-lg-3 col-md-3">
            <div class="genrate_import_section">
                <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.DOWNLOAD_SPREADSHEET' | transloco }}</h4>
                <!-- (click)="open1(mymodal_get_template)" -->
                <app-download-tree-node [menuData]="menuData" *ngIf="menuData?.length > 0"> </app-download-tree-node>
            </div>

            <ng-template #mymodal_get_template let-modal>
                <div class="modal-header">
                    <h4>Upload Templates</h4>
                    <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
                </div>
                <div class="modal-body output-lable">
                    <div class="row" style="margin: 0 auto">
                        <div class="col-md-6">
                            <mat-select [(ngModel)]="formData.material_select" name="material_select" class="dropdown-wrapper" panelClass="dropdown-wrapper">
                                <mat-option value="material">Select Material</mat-option>
                                <mat-option value="material2">Select Material</mat-option>
                                <mat-option value="material3">Select Material</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-md-6">
                            <mat-select
                                [(ngModel)]="formData.material_select_one"
                                name="material_select_one"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-option value="material">Select Material</mat-option>
                                <mat-option value="material2">Select Material</mat-option>
                                <mat-option value="material3">Select Material</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn primary-ebtn">Add</button>
                    <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
                </div>
            </ng-template>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3">
            <div class="import_section">
                <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.UPLOAD_SPREADSHEET' | transloco }}</h4>

                <app-upload-tree-node (reloadUploadHostory)="reloadUploadHostory($event)"> </app-upload-tree-node>
            </div>

            <ng-template #mymodal_template let-modal>
                <div class="modal-header">
                    <h4>Upload Templates</h4>
                    <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
                </div>
                <div class="modal-body addLibrary_body">
                    <div class="row">
                        <div class="col-sm-4">
                            <mat-label class="font-style font-styletwo">Select File Or Drop File</mat-label>
                        </div>
                        <div class="col-sm-8">
                            <ng-container>
                                <!-- <br /> -->
                                <div class="upload_file">
                                    <p-fileUpload
                                        name="demo[]"
                                        url="./upload.php"
                                        (onUpload)="onUpload($event)"
                                        multiple="multiple"
                                        cancelLabel="PDF, DOC, JPG, PNG"
                                        cancelIcon=" "
                                        chooseLabel=" "
                                        uploadIcon=" "
                                        chooseIcon="pi pi-upload"
                                        uploadLabel="Upload Files"
                                        maxFileSize="1000000"
                                    >
                                        <ng-template pTemplate="content">
                                            <ul *ngIf="uploadedFiles.length">
                                                <li *ngFor="let file of uploadedFiles">
                                                    {{ file.name }} - {{ file.size }}
                                                    bytes
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </p-fileUpload>
                                </div>
                                <!-- <br /> -->
                            </ng-container>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <mat-label class="font-style font-styletwo">Comments</mat-label>
                        </div>
                        <div class="col-md-8">
                            <input matInput type="text" placeholder="Comments" class="new_input_field setting_input_field" name="comments" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn primary-ebtn" (click)="open1(upload_template)">Upload Templates</button>
                    <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
                </div>
            </ng-template>

            <ng-template #upload_template let-modal>
                <div class="modal-header">
                    <h4>Preview</h4>
                    <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
                </div>
                <div class="modal-body addLibrary_body">
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field>
                                <input matInput type="text" placeholder="Item Type" name="item_type" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field>
                                <input matInput type="number" placeholder="Total Number Of Items" name="items" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field>
                                <input matInput type="number" placeholder="Total Number Of Errors" name="errors" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Data</h3>
                        </div>
                        <div class="col-md-12">
                            <app-data-table></app-data-table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn primary-ebtn">Skip Errors and Upload</button>
                    <button type="button" class="btn secondary-ebtn">Download Errors</button>
                    <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
                </div>
            </ng-template>
        </div>
        <div class="col-md-6 pt-6 pb-6"></div>
    </div>

    <div class="row mt-4 mb-4" style="margin: 0 auto">
        <div class="col-md-12">
            <!-- <h4>Data Restore</h4> -->
            <app-data-restore-table [uploadHistory]="uploadHistory" *ngIf="uploadHistory"></app-data-restore-table>
        </div>
    </div>
</div>
